import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IPaginationResult, IPaginationResultFrequencies } from "app/common/interfaces";
import {  CombinedFilter } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { subRoutesFrecuencyRequestDto, subRoutesFrecuencyResponseDto } from "./dto/sub-route-reports.dto";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "route_reports";

@Injectable({
  providedIn: "root",
})
export class CustomerRouteFrequencyService extends AbstractService<any, any, any> {

  /** The last filter used to load the list */
  currentFilter: subRoutesFrecuencyRequestDto;

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    /**
     * Pagination
     * @param options Pagination options
     * @returns Paginated data
     */
    findAllWithCount(
        dataToSend: subRoutesFrecuencyRequestDto,
    ): Observable<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>> {
        // Store current filter for exports
        this.currentFilter = { ...dataToSend };
        
        const API_URL: string =
        apiUrl +
        `api/${moduleName}/subRoutesByFrecuency`;
        return this.http.post<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>>(API_URL, dataToSend);
    }

    /**
     * Método wrapper para exports que maneja la llamada HTTP con los parámetros proporcionados
     */
    filterForExport(exportData: subRoutesFrecuencyRequestDto): Observable<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>> {
        const API_URL: string = apiUrl + `api/${moduleName}/subRoutesByFrecuency`;
        return this.http.post<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>>(API_URL, exportData, {
            headers: { 'x-ave-ctx': 'export' }
        });
    }
}
